import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Ng1LiveChatService } from '../../../shared/ng1/ng1-live-chat.service';
import { ConfirmDialogComponent } from '../../../shared/dialog/confirm-dialog/confirm-dialog.component';
import { AmplitudeService } from 'app/shared/services/amplitude.service';

@Component({
  selector: 'cc-cancel-account',
  templateUrl: './cancel-account.component.html',
  styleUrls: ['./cancel-account.component.scss']
})
export class CancelAccountComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    public ng1LiveChatService: Ng1LiveChatService,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit() {}

  cancelSubscription() {
    this.amplitudeService.logEvent('Panel:Account:Remove: Start');
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'PLANS.CANCEL_SUBSCRIPTION.MODAL.TITLE',
          body: 'PLANS.CANCEL_SUBSCRIPTION.MODAL.DESCRIPTION',
          confirm: 'PLANS.CANCEL_SUBSCRIPTION.MODAL.CONFIRM'
        }
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.amplitudeService.logEvent('Panel:Account:Remove: Confirmed');
          this.ng1LiveChatService.contactSupport();
        } else {
          this.amplitudeService.logEvent('Panel:Account:Remove: Cancel');
        }
      });
  }
}
